
import Vue from 'vue';
import FragmentsEditor from '@/components/FragmentsEditor.vue';
import LabelPickerInformation from '@/components/LabelPickerInformation.vue';
import api from '@/rest-api';
import { ExpandedFragment, IngestTextFragment } from '@/model';

export default Vue.extend({
  name: 'FragmentsEditorDialog',
  components: { FragmentsEditor, LabelPickerInformation },
  props: {
    fragmentIds: { type: Array as () => number[] | undefined, required: false },
    newFragment: { type: Object as () => IngestTextFragment | undefined, required: false },
  },

  data() {
    return {
      changedFragments: [] as IngestTextFragment[],
      hasChanges: false,
      cleanup: () => {},
      showSemanticSearch: true,
      showAssistant: false,
    };
  },

  mounted() {
    this.changedFragments = [];
    this.hasChanges = false;
    const overflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden'; // prevent scrolling of FragmentSelectionView
    document.addEventListener('keydown', this.keydown);
    this.cleanup = () => {
      document.documentElement.style.overflow = overflow;
      document.removeEventListener('keydown', this.keydown);
    };
    const showSemanticSearch = localStorage.getItem('showSemanticSearch');
    this.showSemanticSearch = showSemanticSearch !== 'false';
    this.showAssistant = localStorage.getItem('showFragmentAssistant') === 'true';
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    load(fragmentIds: number[]): Promise<ExpandedFragment[]> {
      return api.expandedFragmentsById(fragmentIds);
    },
    fragmentChanged(fragment: IngestTextFragment) {
      this.changedFragments.push(fragment);
    },
    close() {
      // eslint-disable-next-line no-alert
      if (!this.hasChanges || window.confirm('Discard unsaved changes?')) {
        if (this.changedFragments.length > 0) {
          this.$emit('fragmentsChanged', this.changedFragments);
        }
        document.documentElement.style.overflow = 'auto';
        this.$emit('close');
      }
    },
    keydown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
      // ctrl + a -> toggle the assistant pane (but leave select-all alone while typing)
      if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
        const target = e.target as HTMLElement | null;
        const editable = !!target && (target.isContentEditable
          || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA');
        if (!editable) {
          e.preventDefault();
          this.toggleAssistant();
        }
      }
    },
    toggleSemanticSearch() {
      this.showSemanticSearch = !this.showSemanticSearch;
      localStorage.setItem('showSemanticSearch', String(this.showSemanticSearch));
    },
    toggleAssistant() {
      this.showAssistant = !this.showAssistant;
      localStorage.setItem('showFragmentAssistant', String(this.showAssistant));
    },
  },
});
